export default "__VITE_ASSET__BFNqbOyp__"